import { OrderItem } from '@/data/types/Order';

const getTime = (item: OrderItem) =>
	new Date(item.lastUpdateDate || item.createDate || 0).getTime();

export const getLastAddedChildPartNumber = (
	orderItems: OrderItem[] | undefined
): string | undefined => {
	if (!orderItems?.length) return undefined;

	const latest = [...orderItems].sort((a, b) => getTime(b) - getTime(a))[0];

	return latest?.partNumber.split('-T')[0] || undefined;
};
